<template>
    <el-dialog
        class="header_setting"
        :visible.sync="settingVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        append-to-body
        width="800px"
        title="个人设置"
    >
        <el-form
            :model="infoForm"
            ref="infoForm"
            label-width="100px"
            class="formCont"
        >
            <el-row>
                <el-col :span="24">
                    <el-form-item label="头像" size="small" prop="avatar">
                        <div class="userinfo">
                            <div class="avatar" v-loading="loading">
                                <el-avatar
                                    :size="120"
                                    :src="infoForm.avatar || avatar"
                                ></el-avatar>
                                <el-upload
                                    action
                                    :auto-upload="true"
                                    accept=".jpg,.jpeg,.png"
                                    :file-list="fileList"
                                    :limit="1"
                                    :before-upload="beforeUpload"
                                    :on-change="uploadAvatar"
                                >
                                    <p slot="trigger" class="avatar-edit">
                                        编辑
                                    </p>
                                </el-upload>
                            </div>
                            <div class="info">
                                <el-row>
                                    <el-col :span="24">
                                        <div class="info-item">
                                            {{ infoForm.full_depart_name }}
                                            <el-tag size="mini">{{
                                                infoForm.status_cn
                                            }}</el-tag>
                                        </div>
                                    </el-col>
                                    <el-col :span="24">
                                        <div class="info-item">
                                            入职时间 : {{ infoForm.entry_date }}
                                        </div>
                                    </el-col>
                                    <el-col :span="24">
                                        <div class="info-item">
                                            转正时间 :
                                            {{ infoForm.effect_date }}
                                        </div>
                                    </el-col>
                                </el-row>
                            </div>
                        </div>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item
                        label="真实姓名"
                        size="small"
                        :rules="[{ required: true, message: '请输入真实姓名' }]"
                        prop="name"
                    >
                        <el-input
                            clearable
                            placeholder="请输入真实姓名"
                            maxlength="30"
                            size="small"
                            v-model="infoForm.name"
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="英文名称" size="small">
                        <el-input
                            clearable
                            placeholder="请输入英文名称"
                            maxlength="30"
                            size="small"
                            v-model="infoForm.name_en"
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item
                        label="联系电话"
                        size="small"
                        :rules="[{ required: true, message: '请输入联系电话' }]"
                        prop="phone"
                    >
                        <el-input
                            clearable
                            placeholder="请输入联系电话"
                            maxlength="30"
                            size="small"
                            v-model.number="infoForm.phone"
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item
                        label="性别"
                        size="small"
                        style="text-align: left"
                    >
                        <el-radio v-model="infoForm.sex" :label="1"
                            >男</el-radio
                        >
                        <el-radio v-model="infoForm.sex" :label="2"
                            >女</el-radio
                        >
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="学历" size="small">
                        <el-select
                            v-model="infoForm.education"
                            size="small"
                            placeholder="请选择学历"
                        >
                            <el-option
                                v-for="item in educationList"
                                :key="item"
                                :label="item"
                                :value="item"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="籍贯" size="small">
                        <el-input
                            clearable
                            placeholder="请输入籍贯"
                            maxlength="50"
                            size="small"
                            v-model="infoForm.hometown"
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="电子邮箱" size="small">
                        <el-input
                            clearable
                            placeholder="请输入电子邮箱"
                            maxlength="50"
                            size="small"
                            v-model="infoForm.email"
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="出生日期" size="small">
                        <el-date-picker
                            v-model="infoForm.birthday"
                            type="date"
                            placeholder="选择日期"
                            value-format="yyyy-MM-dd"
                            format="yyyy-MM-dd"
                            style="width: 100%"
                        >
                        </el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="紧急联系人" size="small">
                        <el-input
                            clearable
                            placeholder="请输入紧急联系人"
                            maxlength="30"
                            size="small"
                            v-model="infoForm.urgent_person"
                        >
                        </el-input>
                    </el-form-item> </el-col
                ><el-col :span="12">
                    <el-form-item label="专业" size="small">
                        <el-input
                            clearable
                            placeholder="请输入专业"
                            maxlength="30"
                            size="small"
                            v-model="infoForm.speciality"
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="紧急联系电话" size="small">
                        <el-input
                            clearable
                            placeholder="请输入紧急联系电话"
                            maxlength="30"
                            size="small"
                            v-model="infoForm.urgent_phone"
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item
                        label="是否已婚"
                        size="small"
                        style="text-align: left"
                    >
                        <el-radio v-model="infoForm.marriage" :label="1"
                            >已婚</el-radio
                        >
                        <el-radio v-model="infoForm.marriage" :label="0"
                            >未婚</el-radio
                        >
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="联系地址" size="small">
                        <el-input
                            clearable
                            placeholder="请输入联系地址"
                            maxlength="30"
                            size="small"
                            v-model="infoForm.address"
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="save"
                >保存</el-button
            >
            <el-button size="small" @click="settingVisible = false"
                >关闭</el-button
            >
        </span>
    </el-dialog>
</template>
<script>
import { mapState } from "vuex";
import * as api from "@/http/api.js";
import * as oaApi from "@/http/oaApi.js";

export default {
    data() {
        return {
            infoForm: {
                avatar: "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
            },
            fileList: [],
            loading: false,
        };
    },
    methods: {
        closeDialog() {
            this.infoForm = JSON.parse(JSON.stringify(this.userInfo));
            this.$refs["infoForm"].resetFields();
            this.$refs["infoForm"].clearValidate();
            this.$emit("update:settingVisible", false);
        },
        save() {
            this.$refs["infoForm"].validate((valid) => {
                if (valid) {
                    oaApi
                        .user(this.infoForm, "put", this.infoForm.id)
                        .then((res) => {
                            if (res) {
                                this.$message.success("保存成功");
                                this.$store.dispatch("getUserInfo");
                                this.closeDialog();
                            }
                        });
                }
            });
        },
        beforeUpload(file) {
            var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
            const extension = testmsg === "jpg" || testmsg === "png";
            const isLt2M = file.size / 1024 / 1024 < 5; //这里做文件大小限制
            if (!extension) {
                this.$message.warning("上传头像只能是 jpg、png格式!");
                return false;
            }
            if (!isLt2M) {
                this.$message.warning(`上传头像大小不能超过 5 MB!`);
                return false;
            }
            return extension || (extension2 && isLt2M);
        },
        uploadAvatar(file) {
            this.loading = true;
            api.ossImageUpload().then((res) => {
                var formData = new FormData();
                let fileName = res.filename + "." + file.raw.type.split("/")[1];
                formData.append("policy", res.policy);
                formData.append("OSSAccessKeyId", res.accessid);
                formData.append("success_action_status", 200);
                formData.append("signature", res.signature);
                formData.append("key", fileName);
                formData.append("callback", res.callback);
                formData.append("file", file.raw); //file.source.source 图片类型对象
                fetch(res.host, {
                    method: "post",
                    mode: "cors",
                    body: formData,
                })
                    .then((res) => res.json())
                    .then((res) => {
                        this.loading = false;
                        this.infoForm.avatar = res.data.url;
                    })
                    .catch((e) => {
                        console.log(e);
                    });
            });
        },
    },
    props: {
        settingVisible: Boolean,
    },
    computed: {
        ...mapState({
            userInfo: (state) => state.login.userInfo, // 用户信息
            avatar: (state) => state.login.avatar, // 用户信息
            educationList: (state) => state.index.education, // 学历列表
        }),
    },
    watch: {
        settingVisible: {
            handler(newValue) {
                if (newValue) {
                    this.infoForm = JSON.parse(JSON.stringify(this.userInfo));
                    // this.infoForm.avatar = this.avatar;
                }
            },
            immediate: false,
            deep: true,
        },
    },
};
</script>
<style lang="scss">
.header_setting {
    .userinfo {
        padding-left: 0.05rem;
        display: flex;
        align-items: center;
        .avatar {
            overflow: hidden;
            position: relative;
            width: 120px;
            height: 120px;
            border-radius: 50%;
            &:hover {
                .avatar-edit {
                    // bottom: 0px;
                    &:active {
                        opacity: 0.6;
                    }
                }
            }
            .avatar-edit {
                content: "编辑";
                cursor: pointer;
                font-size: 14px;
                color: #ffffff;
                text-align: center;
                position: absolute;
                bottom: 0px;
                left: 0;
                height: 35px;
                line-height: 35px;
                width: 100%;
                display: block;
                background: rgba($color: #000000, $alpha: 0.8);
                transition: bottom 0.7s;
            }
        }
        .el-avatar {
            img {
                position: absolute;
                left: 50%;
                transform: translateX(-50%);
            }
        }
        .info {
            margin-left: 35px;
            .info-item {
                font-size: 12px;
            }
        }
    }
}
</style>
